import React, { useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { create_activation_code } from "../../../services/admin";

const availableCodeKeys = [
  { key: "VITALICIO", label: "Vitalicio" },
  { key: "TEN_YEARS", label: "10 años" },
  { key: "THREE_YEARS", label: "3 años" },
  { key: "ONE_YEAR", label: "1 año" },
  { key: "SIX_MONTHS", label: "6 meses" },
  { key: "THREE_MONTHS", label: "3 meses" },
  { key: "ONE_MONTH", label: "1 mes" },
];

const GenerateCodeModal = ({ show, handleClose, onCreated }) => {
  const [codeKey, setCodeKey] = useState(availableCodeKeys[0].key);
  const [loading, setLoading] = useState(false);

  const handleGenerate = async () => {
    setLoading(true);

    try {
      await create_activation_code(codeKey);

      handleClose();
      onCreated();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Generar Código de Activación</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>Duración de la suscripción</Form.Label>

            <Form.Select
              value={codeKey}
              onChange={(e) => setCodeKey(e.target.value)}
            >
              {availableCodeKeys.map(({ key, label }) => (
                <option key={key} value={key}>
                  {label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancelar
        </Button>

        <Button variant="primary" onClick={handleGenerate} disabled={loading}>
          {loading ? <Spinner size="sm" /> : "Generar código"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GenerateCodeModal;
